import { render, staticRenderFns } from "./text-editor-with-table.vue?vue&type=template&id=c8355df6"
import script from "./text-editor-with-table.vue?vue&type=script&lang=js"
export * from "./text-editor-with-table.vue?vue&type=script&lang=js"
import style0 from "./text-editor-with-table.vue?vue&type=style&index=0&id=c8355df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports